/* tslint:disable */

/**
 */
export class SelectedMeshPointElm {
    unit?: string;
    value?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/selected-mesh-point-elm.ts